<template>
  <card>
    <div class="box__title">
      <div>배송수단</div>
    </div>
    <div class="options">
      <div
        v-for="(list, idx) in vehicles.categories"
        :key="idx"
        class="options__item"
        @click="handleVehicleCategory(list)"
        :class="{
          'options__item--active':
            getDeliveryOptions.vehicleCategory === list.code,
        }"
      >
        <div class="for">
          <bubble
            v-if="list.bubbleComment"
            :class="{
              active: getDeliveryOptions.vehicleCategory === list.code,
            }"
            :description="list.bubbleComment"
          />
        </div>
        <img :src="list.image" />
        <div class="options__title">
          <svg
            v-if="getDeliveryOptions.vehicleCategory === list.code"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5008 13.6L16.4008 7.70005C16.5841 7.51672 16.8174 7.42505 17.1008 7.42505C17.3841 7.42505 17.6174 7.51672 17.8008 7.70005C17.9841 7.88338 18.0758 8.11671 18.0758 8.40005C18.0758 8.68338 17.9841 8.91672 17.8008 9.10005L11.2008 15.7C11.0008 15.9 10.7674 16 10.5008 16C10.2341 16 10.0008 15.9 9.80078 15.7L7.20078 13.1C7.01745 12.9167 6.92578 12.6834 6.92578 12.4C6.92578 12.1167 7.01745 11.8834 7.20078 11.7C7.38411 11.5167 7.61745 11.425 7.90078 11.425C8.18411 11.425 8.41745 11.5167 8.60078 11.7L10.5008 13.6Z"
              fill=""
            />
          </svg>
          <span>{{ list.displayName }}</span>
        </div>
      </div>
    </div>
    <div
      class="option__sub-box"
      v-if="getDeliveryOptions.vehicleItemCode === 1"
    >
      <div
        class="option__sub-title"
        :class="{
          'option__sub-title--active':
            getDeliveryOptions.vehicleType === list.code,
        }"
        @click="updateVehicleType(list.code)"
        v-for="(list, idx) in typeSelectList"
      >
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5008 13.6L16.4008 7.70005C16.5841 7.51672 16.8174 7.42505 17.1008 7.42505C17.3841 7.42505 17.6174 7.51672 17.8008 7.70005C17.9841 7.88338 18.0758 8.11671 18.0758 8.40005C18.0758 8.68338 17.9841 8.91672 17.8008 9.10005L11.2008 15.7C11.0008 15.9 10.7674 16 10.5008 16C10.2341 16 10.0008 15.9 9.80078 15.7L7.20078 13.1C7.01745 12.9167 6.92578 12.6834 6.92578 12.4C6.92578 12.1167 7.01745 11.8834 7.20078 11.7C7.38411 11.5167 7.61745 11.425 7.90078 11.425C8.18411 11.425 8.41745 11.5167 8.60078 11.7L10.5008 13.6Z"
          />
        </svg>
        <div>{{ list.displayName }}</div>
      </div>
    </div>
    <div
      class="option__sub-box truck-select option__sub-box--truck"
      v-if="getDeliveryOptions.vehicleItemCode === 2"
    >
      <div class="truck-select">
        <div class="box__title">차종선택</div>
        <customSelect
          :options="typeSelectList"
          v-model="typeValue"
          placeHolder="차종선택"
        ></customSelect>
      </div>
      <div class="truck-select truck-select__mobile">
        <div class="box__title">차량 특성 선택</div>
        <customSelect
          :options="optionSelectList"
          v-model="optionValue"
        ></customSelect>
      </div>
    </div>
  </card>
</template>
<script>
import bubble from "./bubble.vue";
import customSelect from "@/components/common/CustomSelect/layout.vue";
import card from "@/components/common/card.vue";
import mixinOrder from "@/mixins/mixinOrder";

export default {
  mixins: [mixinOrder],
  props: ["vehicles"],
  components: { customSelect, card, bubble, customSelect },
  data() {
    return {
      typeValue: null,
      optionValue: null,
      types: [],
      options: [],
    };
  },

  watch: {
    "getDeliveryOptions.vehicleCategory": {
      handler(val) {
        if (val === null) return;
        this.getVehicleTypes();
      },
    },
    "getDeliveryOptions.vehicleItemCode": {
      handler(val) {
        this.updateClientComment("");
        if (val !== null && val === 1) {
          this.$emit("calculator");
        }
      },
    },
    "getDeliveryOptions.vehicleType": {
      handler(val) {
        this.getVehicleOptions();
      },
    },
    typeValue: {
      handler(val) {
        this.updateVehicleType(val);
      },
    },
    optionValue: {
      handler(val) {
        if (this.getDeliveryOptions.vehicleOption !== val) {
          this.updateVehicleOptions(val);
          this.$emit("calculator");
        }
      },
    },
  },

  computed: {
    optionSelectList() {
      return this.options;
    },
    typeSelectList() {
      return this.types;
    },
  },
  methods: {
    getVehicleOptions(skip = true) {
      let fullopton = [];
      if (this.getDeliveryOptions.vehicleType === null) return;
      const type = this.vehicles.types.find(
        (item) => item.code === this.getDeliveryOptions.vehicleType
      );

      if (type && type.childVehicleOptionCodes.length > 0) {
        const childCodes = type.childVehicleOptionCodes;
        fullopton = this.vehicles.options.filter((option) =>
          childCodes.includes(option.code)
        );
      }

      const modifiedData = fullopton.map((item) => {
        return {
          amount: item.amount,
          value: item.code,
          title: item.displayName,
        };
      });

      this.options = modifiedData;
      if (modifiedData.length > 0) {
        this.optionValue = skip
          ? modifiedData[0].value
          : this.getDeliveryOptions.vehicleOption;
        this.updateVehicleOptions(
          skip ? modifiedData[0].value : this.getDeliveryOptions.vehicleOption
        );
        this.$emit("calculator");
      }
    },
    getVehicleTypes(skip = true) {
      if (this.getDeliveryOptions.vehicleCategory === null) return;
      const selectedCategory = this.vehicles.categories.find(
        (c) => c.code === this.getDeliveryOptions.vehicleCategory
      );
      if (!selectedCategory.childVehicleTypeCodes) return;
      this.types = [];
      const types = this.vehicles.types.filter((type) =>
        selectedCategory.childVehicleTypeCodes.includes(type.code)
      );

      if (this.getDeliveryOptions.vehicleCategory === 8) {
        const modifiedData = types.map((item) => {
          return {
            childVehicleOptionCodes: item.childVehicleOptionCodes,
            value: item.code,
            title: item.displayName,
          };
        });
        this.types = modifiedData;
        this.typeValue = skip
          ? selectedCategory.defaultTypeCode
          : this.getDeliveryOptions.vehicleType;
      } else {
        this.types = types;
      }
      this.updateVehicleType(
        skip
          ? selectedCategory.defaultTypeCode
          : this.getDeliveryOptions.vehicleType
      );

      if (!skip) {
        this.getVehicleOptions(false);
      }
    },
    handleVehicleCategory(list) {
      this.updateVehicleCategory(list.code),
        this.updateVehicleType(list.defaultTypeCode),
        (this.typeValue = list.defaultTypeCode);
      this.updateVehicleItemCode(list.itemCode);
      if (list.itemCode === 1) {
        this.resetVehicleOptions();
      } else {
        this.updateWeight(3);
        this.updateItem("document", 0, false);
        this.updateItem("smallBox", 0, false);
        this.updateItem("bigBox", 0, false);
      }
    },
    resetVehicleOptions() {
      this.updateLoadingPosition(null);
      this.updateUnLoadingPosition(null);
      this.updateLoadingMethod(null);
      this.updateUnLoadingMethod(null);
    },
  },
  created() {
    this.getVehicleTypes(false);
  },
};
</script>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style src="./layout.css" scoped></style>
